import { render } from "./FlowsList.vue?vue&type=template&id=4a7ffbd7"
import script from "./FlowsList.vue?vue&type=script&lang=js"
export * from "./FlowsList.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.28.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__